module.exports = __webpack_public_path__ + "c5418f56fcdd60bf3d24381cd34442ce.png";